export enum ROLE {
    CORPORATE = 'CORPORATE',
    REGISTRATION_ADMIN = 'REGISTRATION_ADMIN',
    MERCHANT = 'MERCHANT',
    CLERK = 'CLERK',
    CONSUMER = 'CONSUMER',
}

export const isOwner = (roles: (keyof typeof ROLE)[] | null): boolean => {
    if (!roles) return false;

    return roles.some((role) => [ROLE.REGISTRATION_ADMIN, ROLE.MERCHANT, ROLE.CORPORATE].includes(ROLE[role]));
};

export const isOwnerPortal = (roles: (keyof typeof ROLE)[] | null): boolean => {
    if (!roles) return false;

    return roles.some((role) => [ROLE.REGISTRATION_ADMIN, ROLE.MERCHANT, ROLE.CORPORATE, ROLE.CLERK].includes(ROLE[role]));
};
